import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, Table } from "reactstrap";
import moment from "moment";

import { withNamespaces } from "react-i18next";

//Import Image
import logo from "../assets/images/logo-light.png";
import { formatUnitsForReport } from "../helpers/units";
const FPPurchaseOrder = (props) => {
  // function printInvoice() {
  //   window.print();
  // }
  // function printInvoice() {
  //   const containerElement = document.getElementsByClassName("page-content")[0];
  //   containerElement.scrollIntoView({ behavior: "smooth", block: "start" });
  //   setTimeout(() => {
  //     window.print();
  //   }, 500);
  // }
  function printInvoice() {
    const containerElement = document.getElementsByClassName("page-content")[0];
    const style = document.createElement("style");
    style.innerHTML = `
      .table thead th {
        background-color: #000 !important; 
        color: #fff !important; 
        -webkit-print-color-adjust: exact; 
      }     
    `;
    document.head.appendChild(style);
    // Scroll to the top of the page content
    containerElement.scrollIntoView({ behavior: "smooth", block: "start" });
  
    setTimeout(() => {
      document.title = `${props.purchase_order?.supplier?.name}_${props.purchase_order?.po_id}_${props.purchase_order?.branch_details?.name}`
      window.print();
      document.head.removeChild(style);
    }, 500);
  }
  const style = {
    top: 0,
    position: "sticky",
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                <div className="d-flex justify-content-between align-items-start mb-4">
  <div>
    <img src={logo} alt="logo" height="35" />
  </div>
  <div className="text-end">
    <h3 className="fw-bold">{props.t("PURCHASE ORDER")}</h3>
    <p className="mb-1">
      <strong>{props.t("PO #")}:</strong> {props.purchase_order?.po_id}
    </p>
    <p className="mb-0">
      <strong>{props.t("Date")}:</strong> {moment(props.purchase_order?.createdAt).format("DD/MM/YYYY")}
    </p>
  </div>
</div>

                  {props.purchase_order &&
                    props.purchase_order.products  &&
                    props.purchase_order.products.length > 0 ? (
                    <>
                      <div className="py-2 mt-3">
                        <h3 className="font-size-15 font-weight-bold">
                          {props.t("Products")}
                        </h3>
                      </div>
                      <div className="table-responsive">
                        <Table className="table-nowrap">
                          <thead style={style}>
                            <tr>
                              <th>{props.t("Name")}</th>
                              <th>{props.t("Section")}</th>
                              <th>{props.t("Category")}</th>
                              <th className="text-right">{props.t("Price")}</th>
                              <th className="text-right">{props.t("Quantity")}</th>
                              <th className="text-right">
                                {props.t("Total Price")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {props.purchase_order &&
                              props.purchase_order.products?.map((item, key) => (
                                <tr>
                                  <td>{item.name}</td>
                                  <td>{item.section}</td>
                                  <td>{item.category}</td>
                                  <td className="text-right">{item.price}/{item.unit_for_cost_price}</td>
                                  <td className="text-right">
                                    {formatUnitsForReport(item.quantity)}
                                  </td>
                                  <td className="text-right">
                                    {(item.total_price).toFixed(2)}
                                  </td>
                                </tr>
                              ))}
                            <tr>
                              <td colSpan="5" className="border-0 text-right">
                                <strong>{props.t("Total")}</strong>
                              </td>
                              <td className="border-0 text-right">
                                {props.purchase_order &&
                                  props.purchase_order.products.reduce(
                                    (accumulator, currentValue) =>
                                      +accumulator + +currentValue.total_price,
                                    0
                                  ).toFixed(2)}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </>
                  ) : (
                 null
                  )}

               {/* Delivery Details     */}
{props.purchase_order && props.purchase_order.delivery_details && props.purchase_order.delivery_details.length > 0 && (
  <>
  <div className="py-2 mt-3">
                        <h3 className="font-size-15 font-weight-bold">
                          {props.t("Delivery Details")}
                        </h3>
                      </div>
                      <div className="table-responsive">
                        <Table className="table-nowrap">
                          <thead style={style}>
                            <tr>
                              <th>{props.t("Name")}</th>
                              <th>{props.t("Category")}</th>
                              <th>{props.t("Free")}</th>
                              
                              <th className="text-right">{props.t("Receiving Date")}</th>
                              <th className="text-right">{props.t("Invoice")}</th>
                              <th className="text-right">{props.t("Price")}</th>
                              <th className="text-right">{props.t("Received")}</th>
                              <th className="text-right">
                                {props.t("Total Price")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {props.purchase_order &&
                              props.purchase_order.delivery_details.map((item, key) => (
                                <tr>
                                  <td>{item.name}</td>
                                  <td>{item.category}</td>
                                  <td>{item.free ? "Yes" : "No"}</td>
                                  
                                  <td className="text-right">{item.receiving_date ? moment(item.receiving_date).format("YYYY-MM-DD HH:mm") : " "}</td>
                                  <td className="text-right">{item.invoice_number}</td>
                                  <td className="text-right">{item.price}/{item.unit_for_cost_price}</td>
                                  <td className="text-right">
                                    {formatUnitsForReport(item.receive)}
                                    {/* {item.receive && item.receive.map((unitObj, index) => (
                                      <span key={index}>
                                        {(unitObj.value) + " " + (unitObj.unit)} &nbsp;
                                      </span>
                                    ))} */}
                                    {/* {`${item.quantity.in_unit} ${item.unit}`} */}
                                  </td>
                                  <td className="text-right">
                                    {(item.total_price).toFixed(2)}
                                  </td>
                                </tr>
                              ))}
                            <tr>
                              <td colSpan="7" className="border-0 text-right">
                                <strong>{props.t("Total")}</strong>
                              </td>
                              <td className="border-0 text-right">
                                {props.purchase_order &&
                                  props.purchase_order.delivery_details.reduce(
                                    (accumulator, currentValue) =>
                                      +accumulator + +currentValue.total_price,
                                    0
                                  ).toFixed(2)}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
  </>
)}
                  <hr />
                  <Table className="table-nowrap">
                    <tbody>
                      <tr>
                        <td className="border-0 ">
                          {/* <strong>{props.t("Additional Note")}</strong> */}
                        </td>
                        <td className="border-0 text-right">
                          <strong>{props.t("AUTHORIZE BY")}</strong>
                        </td>
                      </tr>
                      {/* <tr>
                        <td className="border-0">
                          {props.t(
                            "Payment shall be 30 days upon delivery of the above items."
                          )}
                        </td>
                        <td className="border-0 text-right"></td>
                      </tr> */}
                    </tbody>
                  </Table>
                  <div className="d-print-none">
                    <div className="float-right">
                      <Link
                        to="#"
                        onClick={() => {
                          printInvoice();
                        }}
                        className="btn btn-success waves-effect waves-light mr-2"
                      >
                        <i className="fa fa-print"></i> {props.t("Print")}
                      </Link>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withNamespaces()(FPPurchaseOrder);
